import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

const YAPI = false

export const getUserAwardRules = async (params: object) => {
  return await GET({
    url: YAPI ? 'http://yapi.bingex.com/mock/1082/activityCenter/inviteCourierActivity/getUserAwardRules'
      : '/activityCenter/inviteCourierActivity/getUserAwardRules',
    params,
    showError: false
  })
}

export const getUserAwardPhase = async (params: object) => {
  return await GET({
    url: YAPI ? 'http://yapi.bingex.com/mock/1082/activityCenter/inviteCourierActivity/getUserAwardPhase'
      : '/activityCenter/inviteCourierActivity/getUserAwardPhase',
    params,
    showError: false
  })
}

export const findAwardPage = async (params: object) => {
  return await GET({
    url: YAPI ? 'http://yapi.bingex.com/mock/1082/activityCenter/inviteCourierActivity/findAwardPage'
      : '/activityCenter/inviteCourierActivity/findAwardPage',
    params,
    showError: false
  })
}
